import { render } from "./DrinksView.vue?vue&type=template&id=2d1e87a7"
import script from "./DrinksView.vue?vue&type=script&lang=js"
export * from "./DrinksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__